export type PhaseFileParameters = {
    zohoId?: string;
    fileContent: string;
    fileName: string;
};

export type PhaseExtraFileParameters = {
    zohoId?: string;
    fileName: string;
};

export class PhaseFile {
    DatatypeCode: string;
    CategoryName: string;
    Title: string;
    FileName: string;
    FileContents: string;

    constructor({ fileContent, fileName }: PhaseFileParameters) {
        this.DatatypeCode = "FILE";
        this.CategoryName = "MISC";
        this.Title = fileName;
        this.FileName = fileName;
        this.FileContents = fileContent;
    }
}

export class PhaseExtraFile {
    chECFase_c: string;
    OptyNumber: string;

    constructor({ zohoId }: PhaseExtraFileParameters) {
        this.chECFase_c = "archivo";
        this.OptyNumber = zohoId;
    }
}
